import { useEffect } from 'react';
import createStudyToast from './StudyListToast/StudyToast';
import { studyListCookies } from './studyListCookies';
import useCookie from 'hooks/useCookie';
import { ToastType } from 'components/core';

type ToastMessage = { message: string; type: ToastType };

// Displays any pending toast messages set via cookies by redirecting pages
export const useStudyListCookieToasts = () => {
  const [deTemplatePublished, , clearDeTemplatePublished] = useCookie<boolean>(
    studyListCookies.deTemplatePublished,
    false
  );
  const [deMovedBack, , clearDeMovedBack] = useCookie<boolean>(
    studyListCookies.deMovedBack,
    false
  );
  const [qaTemplatePublished, , clearQaTemplatePublished] = useCookie<boolean>(
    studyListCookies.qaTemplatePublished,
    false
  );
  const [qaMovedBack, , clearQaMovedBack] = useCookie<boolean>(
    studyListCookies.qaMovedBack,
    false
  );
  const [studyInProgress, , clearStudyInProgress] = useCookie<boolean>(
    studyListCookies.studyInProgress,
    false
  );

  useEffect(() => {
    const toastMessages: ToastMessage[] = [];

    if (deTemplatePublished) {
      toastMessages.push({
        message: 'Data extraction template published successfully',
        type: 'success',
      });
      clearDeTemplatePublished();
    }
    if (deMovedBack) {
      toastMessages.push({
        message: 'Studies moved back to “Incomplete”',
        type: 'success',
      });
      clearDeMovedBack();
    }
    if (qaTemplatePublished) {
      toastMessages.push({
        message: 'Quality assessment template published successfully',
        type: 'success',
      });
      clearQaTemplatePublished();
    }
    if (qaMovedBack) {
      toastMessages.push({
        message: 'Studies moved back to “Incomplete”',
        type: 'success',
      });
      clearQaMovedBack();
    }
    if (studyInProgress) {
      toastMessages.push({
        message: 'This study is already in progress. Please choose another.',
        type: 'brand',
      });
      clearStudyInProgress();
    }

    toastMessages.forEach((toast, index) => {
      // Show toasts with a small delay between each toast
      const messageDelay = 500 * index;
      setTimeout(() => {
        createStudyToast({
          toastMessage: toast.message,
          toastType: toast.type,
        });
      }, messageDelay);
    });
  }, []);
};
